import type { TaskBodyProps } from './index';
import { DesignPlanHistory } from './DesignPlanHistory';
import { TaskSidebarPanel } from './TaskSidebarPanel';
import { buildSidebarTabs, DESIGN_TABS, REDESIGN_TABS } from './taskSidebarTabs';

export function ReviewDesignTask({ workCase: c, statusMeta }: TaskBodyProps) {
    // This component serves both the original design review and the redesign
    // review. The revision conversation only exists for redesigns, so the
    // Revisions tab is shown only when the case is in the Redesign phase.
    const isRedesign = statusMeta.macro === 'redesign';
    const sidebarTabs = buildSidebarTabs(c.id, isRedesign ? REDESIGN_TABS : DESIGN_TABS);

    return (
        <div className="flex-1 min-h-0 flex flex-col px-4 pt-3 pb-3">
            {/* Two columns: submitted instructions on the left, patient context on the right */}
            <div className="flex-1 min-h-0 flex gap-3">
                {/* LEFT — submitted Tx instructions (no input field on review) */}
                <div className="flex-[6] min-w-0 flex flex-col">
                    <DesignPlanHistory patientId={c.id} />
                </div>

                {/* RIGHT — full-height sidebar: Patient info, Patient notes, [Revisions,] Dx report tabs */}
                <div className="flex-[4] min-w-0 min-h-0">
                    <TaskSidebarPanel
                        tabs={sidebarTabs}
                        initialKey={isRedesign ? 'revisions' : undefined}
                    />
                </div>
            </div>
        </div>
    );
}
